import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Tasks = ProtectedJsonAPI.extend(
  '/tasks',
  {
    index:   endpoint => endpoint
  }
)